import { cdpClient } from '../client';
import type { Goal, GoalDetailStatsResponse, GoalStatsResponse } from '../types';

export async function fetchGoals(): Promise<Goal[]> {
  const { data, error } = await cdpClient.GET('/goals');
  if (error) throw error;
  return data?.items ?? [];
}

export async function fetchGoalStats(): Promise<GoalStatsResponse> {
  const { data, error } = await cdpClient.GET('/goals/stats');
  if (error) throw error;
  return data ?? { total: [], by_date: [] };
}

export async function fetchGoalDetailStats(
  goal: string,
  startDate?: string,
  endDate?: string,
): Promise<GoalDetailStatsResponse> {
  const { data, error } = await cdpClient.GET('/goals/{goal}/stats', {
    params: {
      path: { goal },
      query: {
        start_date: startDate ?? undefined,
        end_date: endDate ?? undefined,
      },
    },
  });
  if (error) throw error;
  return data ?? { goal, daily_stats: [] };
}
